import * as React from "react";
import { registrationRequest } from "./registration.js";

function moscowInput(timestamp) {
  const parts = new Intl.DateTimeFormat("en-GB", {timeZone:"Europe/Moscow", year:"numeric", month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit", hourCycle:"h23"}).formatToParts(new Date(timestamp * 1000));
  const p = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

export function RegistrationSchedule({ state, onUpdated, onStart, onFinish }) {
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState(() => moscowInput(state.closes_at));
  const [baseDeadline, setBaseDeadline] = React.useState(state.closes_at);
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const dialog = React.useRef(null);
  const outdated = open && state.closes_at !== baseDeadline;
  React.useEffect(() => { if (!open) setDate(moscowInput(state.closes_at)); }, [state.closes_at, open]);
  React.useEffect(() => { if (!open) return; const element = dialog.current; element.showModal(); return () => element.close(); }, [open]);
  async function save(change) {
    if (busy || outdated) return;
    onStart(); setBusy(true); setError(""); setMessage("");
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const next = await registrationRequest("deadline", controller.signal, { ...change, expected_closes_at: baseDeadline });
      setBaseDeadline(next.closes_at); onUpdated(next); setDate(moscowInput(next.closes_at)); setMessage("Срок обновлён. Начало и окончание события перенесены.");
    } catch (e) { setError(e.name === "AbortError" ? "Ответ потерян. Обновите страницу и проверьте срок перед повтором." : e.message); }
    finally { clearTimeout(timeout); setBusy(false); onFinish(); }
  }
  return <div className="king-hill-schedule">
    <button type="button" className="king-hill__preview" onClick={() => { setBaseDeadline(state.closes_at); setDate(moscowInput(state.closes_at)); setError(""); setMessage(""); setOpen(true); }} aria-expanded={open}>Настроить срок регистрации</button>
    {open && <dialog ref={dialog} className="king-hill-schedule__panel" aria-label="Срок регистрации" onCancel={e => { e.preventDefault(); if (!busy) setOpen(false); }}>
      <div className="king-hill-schedule__header"><b>Срок регистрации</b><button type="button" disabled={busy} onClick={() => setOpen(false)} aria-label="Закрыть">×</button></div>
      <p>Укажите время по Москве. Начало события сдвинется вместе с окончанием регистрации; продолжительность сохранится.</p>
      <label htmlFor="king-hill-deadline">Дата и время · МСК</label>
      <input id="king-hill-deadline" type="datetime-local" value={date} onChange={e => setDate(e.target.value)} disabled={busy} />
      <button type="button" disabled={busy || outdated || !date} onClick={() => save({deadline:date})}>Сохранить время</button>
      <div className="king-hill-schedule__quick">{[[60,"+1 час"],[180,"+3 часа"],[1440,"+1 день"]].map(([minutes,label]) => <button type="button" key={minutes} disabled={busy || outdated} onClick={() => save({add_minutes:minutes})}>{label}</button>)}</div>
      {outdated && <p role="alert">Срок изменился. Закройте и откройте настройки, чтобы увидеть актуальное время.</p>}
      {message && <p role="status">{message}</p>}{error && <p role="alert">{error}</p>}
    </dialog>}
  </div>;
}
